var PIN = 'PIN';
var EDIT = 'EDIT';
var DELETE = 'DELETE';
var ACTION_TYPES = {
  PIN: PIN,
  EDIT: EDIT,
  DELETE: DELETE
};
export default ACTION_TYPES;